/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const details = /*#__PURE__*/_jsxs(SVG, {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx(Path, {
    d: "M4 16h10v1.5H4V16Zm0-4.5h16V13H4v-1.5ZM10 7h10v1.5H10V7Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/_jsx(Path, {
    d: "m4 5.25 4 2.5-4 2.5v-5Z"
  })]
});
export default details;
//# sourceMappingURL=details.js.map